import { useMutation, useQueryClient } from '@tanstack/react-query';

import { saveKeyNotes } from './api/saveKeyNoteFn';
import { getKeyNoteKey } from './use-get-key-note';

import type { IKeyNoteData } from 'infrastructure/interfaces';
import type { ModuleType } from 'infrastructure/enums';

interface Props {
  module: ModuleType;
}

export const useSaveKeyNote = ({ module }: Props) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: saveKeyNotes,
    onSuccess(data, vars) {
      const queryKey = getKeyNoteKey({
        module,
        patientGuid: vars.patientGuid,
        showExpired: vars.showExpired,
      });
      queryClient.setQueryData<IKeyNoteData[]>(queryKey, (dataCache) => {
        if (!dataCache) return dataCache;

        if (data) {
          const newData = [data, ...dataCache];
          return newData;
        }
      });
    },
  });
  return { saveNote: mutate, isLoading };
};
